'use client';

export const TOOLTIP_ENTER_TOUCH_DELAY = 0;
export const TOOLTIP_LEAVE_TOUCH_DELAY = 5000;
